export const marketingGame = [
  {
    path: '/digitalMarketing/marketingGame',
    name: 'marketingGame',
    component: () => import('views/digitalMarketing/marketingGame'),
    meta: {
      title: '营销玩法'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/addSpecialActivity',
    name: 'addSpecialActivity',
    component: () => import('views/digitalMarketing/marketingGame/addSpecialActivity'),
    meta: {
      title: '新增特价活动'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/addSpecialGoods',
    name: 'addSpecialGoods',
    component: () => import('views/digitalMarketing/marketingGame/addSpecialGoods'),
    meta: {
      title: '新增特价活动'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/newAddSpecialActivity',
    name: 'newAddSpecialActivity',
    component: () => import('views/digitalMarketing/marketingGame/newAddSpecialActivity'),
    meta: {
      title: '创建特价活动'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/newAddSpecialActivity/addGoodsMerchantCenter',
    name: 'addGoodsMerchantCenter',
    component: () => import('views/digitalMarketing/marketingGame/newAddSpecialActivity/addGoodsMerchantCenter'),
    meta: {
      title: '选择商品'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/newAddSpecialActivity/addGoodsByHand',
    name: 'addGoodsByHand',
    component: () => import('views/digitalMarketing/marketingGame/newAddSpecialActivity/addGoodsByHand'),
    meta: {
      title: '手动添加商品'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/newAddSpecialActivity/editor',
    name: 'editor',
    component: () => import('views/digitalMarketing/marketingGame/newAddSpecialActivity/editor'),
    meta: {
      title: '图文详情'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/newAddSpecialActivity/addGoods',
    name: 'newAddGoods',
    component: () => import('views/digitalMarketing/marketingGame/newAddSpecialActivity/addGoods'),
    meta: {
      title: '创建特价活动'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/newAddSpecialActivity/addGoodsGreatActivity',
    name: 'addGoodsGreatActivity',
    component: () => import('views/digitalMarketing/marketingGame/newAddSpecialActivity/addGoodsGreatActivity'),
    meta: {
      title: '创建特价活动'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/newAddSpecialActivity/onlineStore',
    name: 'addGoodsOnlineStore',
    component: () => import('views/digitalMarketing/marketingGame/newAddSpecialActivity/onlineStore'),
    meta: {
      title: '活动网店'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/addSpecialActivity/goodsBank',
    name: 'goodsBank',
    component: () => import('views/digitalMarketing/marketingGame/addSpecialActivity/goodsBank'),
    meta: {
      title: '商品库'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/addSpecialActivity/pictureBank',
    name: 'pictureBank',
    component: () => import('views/digitalMarketing/marketingGame/addSpecialActivity/pictureBank'),
    meta: {
      title: '商品图片库'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/addSpecialActivity/choosingStore',
    name: 'choosingStore',
    component: () => import('views/digitalMarketing/marketingGame/addSpecialActivity/choosingStore'),
    meta: {
      title: '选择门店'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/addSpecialActivity/choosingStoreSpecial',
    name: 'choosingStoreSpecial',
    component: () => import('views/digitalMarketing/marketingGame/addSpecialActivity/choosingStoreSpecial'),
    meta: {
      title: '特价活动选择门店'
    }
  },
  {
    // 特价活动添加成功页面
    path: '/digitalMarketing/marketingGame/publishSuccess',
    name: 'publishSuccess',
    component: () => import('views/digitalMarketing/marketingGame/publishSuccess'),
    meta: {
      title: '活动分享'
    }
  },
  {
    // 活动数据页面
    path: '/digitalMarketing/marketingGame/statistics',
    name: 'statistics',
    component: () => import('views/digitalMarketing/marketingGame/statistics'),
    meta: {
      title: '活动数据'
    }
  },
  {
    // 营销玩法-全部活动列表
    path: '/digitalMarketing/marketingGame/marketingGameList',
    name: 'marketingGameList',
    component: () => import('views/digitalMarketing/marketingGame/marketingGameList'),
    meta: {
      title: '全部活动',
      keepAlive: true
    }
  },
  {
    // 活动详情
    path: '/digitalMarketing/marketingGame/marketingGameList/viewDetails',
    name: 'viewDetails',
    component: () => import('views/digitalMarketing/marketingGame/marketingGameList/viewDetails'),
    meta: {
      title: '活动详情'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/marketingGameList/viewDetails/editorDetail',
    name: 'editorDetail',
    component: () => import('views/digitalMarketing/marketingGame/marketingGameList/viewDetails/editorDetail'),
    meta: {
      title: '图文详情'
    }
  },
  // {
  //   // 查看海报
  //   path: '/digitalMarketing/marketingGame/marketingGameList/viewPoster',
  //   name: 'viewPoster',
  //   component: () => import('views/digitalMarketing/marketingGame/marketingGameList/viewPoster'),
  //   meta: {
  //     title: '查看海报'
  //   }
  // },
  {
    // 适用门店列表
    path: '/digitalMarketing/marketingGame/marketingGameList/storeList',
    name: 'storeList',
    component: () => import('views/digitalMarketing/marketingGame/marketingGameList/storeList'),
    meta: {
      title: '门店列表'
    }
  },
  {
    // 营销玩法-全部订单列表
    path: '/digitalMarketing/marketingGame/allOrder',
    name: 'allOrder',
    component: () => import('views/digitalMarketing/marketingGame/allOrder'),
    meta: {
      title: '订单管理',
      keepAlive: true
    }
  },
  {
    // 营销玩法-批量处理
    path: '/digitalMarketing/marketingGame/allOrder/handleOrder',
    name: 'handleOrder',
    component: () => import('views/digitalMarketing/marketingGame/allOrder/handleOrder'),
    meta: {
      title: '订单管理'
    }
  },
  {
    // 营销玩法-确认呼叫骑手
    path: '/digitalMarketing/marketingGame/allOrder/confirmCallDriver',
    name: 'confirmCallDriver',
    component: () => import('views/digitalMarketing/marketingGame/allOrder/confirmCallDriver'),
    meta: {
      title: '确认呼叫'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/allOrder/confirmCallDriverNew',
    name: 'confirmCallDriverNew',
    component: () => import('views/digitalMarketing/marketingGame/allOrder/confirmCallDriverNew'),
    meta: {
      title: '确认呼叫'
    }
  },
  {
    // 营销玩法-确认呼叫骑手
    path: '/digitalMarketing/marketingGame/allOrder/orderCancelReason',
    name: 'orderCancelReason',
    component: () => import('views/digitalMarketing/marketingGame/allOrder/orderCancelReason'),
    meta: {
      title: '取消原因'
    }
  },
  {
    // 营销玩法-订单筛选
    path: '/digitalMarketing/marketingGame/allOrder/orderFilter',
    name: 'orderFilter',
    component: () => import('views/digitalMarketing/marketingGame/allOrder/orderFilter'),
    meta: {
      title: '筛选'
    }
  },
  {
    // 营销玩法-订单详情
    path: '/digitalMarketing/marketingGame/allOrder/orderDetail',
    name: 'orderDetail',
    component: () => import('views/digitalMarketing/marketingGame/allOrder/orderDetail'),
    meta: {
      title: '订单详情'
    }
  },

  {
    path: '/digitalMarketing/marketingGame/activityPreview',
    name: 'activityPreview',
    component: () => import('views/digitalMarketing/marketingGame/activityPreview/index.vue'),
    meta: {
      title: '活动预览'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/createQrcode',
    name: 'createQrcode',
    component: () => import('views/digitalMarketing/wechatQrcodeMarketing/createQrcode/index.vue'),
    meta: {
      title: '顾客加好友'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/selectAdMode',
    name: 'selectAdMode',
    component: () => import('views/digitalMarketing/wechatQrcodeMarketing/selectAdMode/index.vue'),
    meta: {
      title: '顾客加好友'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/createSuccess',
    name: 'createSuccess',
    component: () => import('views/digitalMarketing/wechatQrcodeMarketing/createSuccess/index.vue'),
    meta: {
      title: '设置成功'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/wechatQrcodeDetail',
    name: 'wechatQrcodeDetail',
    component: () => import('views/digitalMarketing/wechatQrcodeMarketing/wechatQrcodeDetail/index.vue'),
    meta: {
      title: '设置成功'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/wechatQrcodeList',
    name: 'wechatQrcodeList',
    component: () => import('views/digitalMarketing/wechatQrcodeMarketing/wechatQrcodeList/index.vue'),
    meta: {
      title: '微信码列表'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/noQrcodeDataForManage',
    name: 'noQrcodeDataForManage',
    component: () => import('views/digitalMarketing/wechatQrcodeMarketing/noQrcodeDataForManage/index.vue'),
    meta: {
      title: '店长查看无数据页面'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/noStoreForShopOwner',
    name: 'noStoreForShopOwner',
    component: () => import('views/digitalMarketing/wechatQrcodeMarketing/noStoreForShopOwner/index.vue'),
    meta: {
      title: '店长查看无数据页面'
    }
  },
  {
    path: '/digitalMarketing/marketingGame/addSpecialActivity/deliverType',
    name: 'addSpecialDeliverType',
    component: () => import('views/digitalMarketing/marketingGame/addSpecialActivity/deliverType/index.vue'),
    meta: {
      title: '店长查看无数据页面'
    }
  }
]
